// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3Cnev","options":"AnswerScale_options__2WDsp","selected":"AnswerScale_selected__25ZVk"};